import React from "react";
import TermsAndCondition from "../Components/Other/TermsAndCondition";
const TermsPage = () => {
  return <TermsAndCondition />;
};

export default TermsPage;
